import { css } from 'styled-components';
import { Radius } from './Border';
import * as BaseColor from './Color';
import { Size } from './Spacing';
export const Tile = {
    Spacing: {
        XSmall: Size.XSmall,
        Small: Size.Small,
    },
};
export const PopupMenu = {
    Button: {
        Size: 40,
    },
};
export const Folder = {
    Button: {
        Type: 'secondary',
    },
    IconWrapper: 'folder---46',
    FolderStyle: 'default',
    Color: {
        Background: BaseColor.Neutrals.Light,
        Title: BaseColor.Neutrals.Dark,
        Subtitle: BaseColor.Neutrals.Text,
    },
};
export const Empty = {
    Icon: 'ghost-smile---neutral',
    Margin: {
        Size: {
            Medium: Size.MediumLarge,
        },
    },
};
export const QrCode = {
    Badge: {
        Pro: 'crown---circle---yellow',
        Size: 'Small',
    },
    Size: {
        Height: 136,
        Width: 120,
    },
};
export const Tabs = {
    Inactive: {
        BorderSize: 0,
    },
    Margin: {
        Bottom: Size.Medium,
    },
};
export const Alert = {
    Info: {
        Icon: 'alert-info',
        Border: {
            Size: Radius.Medium,
            Color: BaseColor.Feedback.InfoSpecial,
        },
        Element: 'transparent',
    },
};
export const AiLogo = {
    Header: {
        Icon: 'arrow-upload',
        Angle: 270,
        Divider: false,
    },
    Button: {
        Submit: 'column',
    },
};
export const AiImage = {
    Header: {
        Icon: {
            Name: 'stars-add---square',
            Color: BaseColor.Brand.Primary,
            Size: 'Medium',
        },
    },
};
export const Skeleton = {
    Color: {
        Dark: 'rgba(0, 0, 0, 0.06)',
        Light: 'rgba(0, 0, 0, 0.15)',
    },
    Animation: {
        Gradient: {
            Start: 25,
            Center: 37,
            End: 63,
        },
        Background: 400,
    },
};
export const ToolBar = {
    wrapperSize: 414,
    contentContainer: 320,
    drawerGap: 78,
    navigationGap: 0,
    padding: 16,
};
export const Scrollbar = {
    NormalWidth: 5,
    ThinWidth: 2,
};
export const Section = {
    Effects: {
        Icons: {
            Highlight: 'effect-highlight---48',
            Underline: 'effect-underline---48',
            LineThrough: 'effect-line-through---48',
            Stroke: 'effects-stroke---48',
        },
    },
};
export const Background = BaseColor.Neutrals.Paper;
export const Tooltip = {
    Color: {
        Background: BaseColor.Neutrals.Text,
        Text: BaseColor.NeutralsFixed.Light,
    },
};
export const Panel = {
    Background: BaseColor.Neutrals.Paper,
    BackgroundHover: BaseColor.Neutrals.Light,
    Divider: {
        Color: BaseColor.Neutrals.Light,
    },
};
export const AiAssistant = {
    Background: css `
    backdrop-filter: blur(10px);
    background-color: rgba(255, 255, 255, 0.16);
    border: 1px solid ${BaseColor.Neutrals.Border};
  `,
};
//# sourceMappingURL=Components.js.map